<template>
	<g>
		<path id="iconPhone--monitor" style="fill:#463836;" d="M500.45,464.737l-151.273,22.756l-151.273-22.756c0-28.672,0-388.312,0-417.473l151.273-22.756
	L500.45,47.263V464.737z"/>
		<g>
			<path style="fill:#6FC5D6;" d="M500.45,47.263H197.904c0-0.262,0-0.501,0-0.717C197.904,20.946,218.85,0,244.45,0h209.454
		c25.6,0,46.547,20.946,46.547,46.546V47.263z"/>
			<path style="fill:#6FC5D6;" d="M500.45,465.454c0,25.6-20.947,46.546-46.547,46.546H244.45c-25.6,0-46.546-20.946-46.546-46.546
		c0-0.205,0-0.444,0-0.717H500.45V465.454z"/>
		</g>
		<g id="iconPhone--touch">
			<path id="iconPhone--visible" style="fill:#FFD24D;" d="M381.153,211.713c-2.862,0-5.656-1.439-7.269-4.053c-2.476-4.011-1.231-9.268,2.778-11.743
		c15.613-9.637,24.933-26.327,24.933-44.645c0-28.903-23.516-52.419-52.42-52.419c-18.416,0-35.702,9.851-45.115,25.71
		c-2.405,4.054-7.639,5.389-11.693,2.982c-4.053-2.405-5.387-7.64-2.982-11.693c12.471-21.012,35.383-34.065,59.791-34.065
		c38.316,0,69.486,31.171,69.486,69.485c0,24.281-12.349,46.4-33.035,59.168C384.231,211.302,382.681,211.713,381.153,211.713z"/>
			<g>
				<path style="fill:#F99D88;" d="M367.064,381.478l-33.799-1.617l-1.617-33.799c9.783-9.783,25.632-9.783,35.416,0
			S376.848,371.694,367.064,381.478z"/>
				<path style="fill:#F99D88;" d="M331.65,346.062l-33.799-1.617l-1.617-33.799c9.783-9.783,25.632-9.783,35.416,0
			C341.434,320.429,341.432,336.278,331.65,346.062z"/>
				<path style="fill:#F99D88;" d="M296.234,310.646l-33.799-1.617l-1.617-33.799c9.783-9.783,25.632-9.783,35.416,0
			C306.017,285.013,306.017,300.863,296.234,310.646z"/>
			</g>
			<path style="fill:#FAD4C6;" d="M260.818,275.231l104.694-104.694c9.783-9.783,9.783-25.632,0-35.416s-25.632-9.783-35.416,0
		c0,0-146.264,146.264-169.346,169.346c-23.782,23.782-33.533,56.156-28.697,87.026L11.55,512h166.663l37.173-37.173
		c30.869,4.836,63.245-4.915,87.026-28.697c26.525-26.525,64.652-64.652,64.652-64.652L260.818,275.231z"/>
		</g>
	</g>
</template>

<script>

	import { TimelineMax } from 'gsap'

	export default {
		name: "IconPhone.vue",
		data: function () {
			return {
				tl:undefined,
			}
		},
		methods: {
			start() {
				this.tl = new TimelineMax({repeat: -1});
				this.tl.to('#iconPhone--touch', 2, { y: 50 });
				this.tl.to('#iconPhone--touch',3 ,{ y: 0 });
				this.tl.set('#iconPhone--touch', { y: 0 });
			},
			stop(){
				this.tl.kill();
			},
			pause() {
				this.tl.pause();
			},
			play() {
				if (this.tl.paused()) {
					this.tl.play();
				}
			}
		}
	}
</script>

<style scoped>

</style>
